import React, { useState, useEffect, useContext, useRef } from 'react';
import stylesCalender from './style.module.css';
import stylesGlobal from '../../styles/referral/global.module.css';
import clsx from 'clsx';
import ReactDOM from 'react-dom';

import closeIcon from '../../assets/images/referral/closeicon.png';
import { CalenderProps } from '../../utils/CommonType';
import { useTranslation } from 'react-i18next';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import './extra.css';

import clanderIcon from '../../assets/images/referral/calendar.png';
import CalenderContext from '../../context/CalenderContext';
import TransactionHistoryContext from '../../context/TransactionHistory';

import monthControlLeftIcon from '../../assets/images/referral/monthcontrolleft.png';
import monthControlRightIcon from '../../assets/images/referral/monthcontrolright.png';
import { toast } from 'react-toastify';

export const FromDatePicker = ({datepickerRefFrom}: {datepickerRefFrom:any}) => {
    const { startDate, setStartDate, isDateValid, setIsDateValid } = useContext(CalenderContext);
    const [tempDate, setTempDate] = useState<Date | null>(null);
    const [isOpen, setIsOpen] = useState(false);


    const handleCancel = () => {
        setTempDate(startDate); // Reset temp date to previously selected date
        setIsOpen(false); // Close the calendar
        setIsDateValid(false);
      };
    
      const handleOk = () => {
        setStartDate(tempDate); // Save selected date
        setIsOpen(false); // Close the calendar
        setIsDateValid(false);
      };

      const focusOnFromDateInput = () => { 
        setIsOpen(true);
        setIsDateValid(false);
       // datepickerRefFrom.current?.focus();
      }

    return <div className={clsx(stylesGlobal.flex1, 'flex', 'justifyContentFS', 'alignItemCenter', 'gap5', stylesCalender.calenderItem, isOpen && stylesCalender.calenderItemOpenTrue, isDateValid && stylesCalender.calenderItemError)} >
         
             <div className={clsx(stylesGlobal.flex1, stylesCalender.calenderLabel, 'moveupwithouterrorwrapperdiv')}>
               <label className={clsx(stylesGlobal.flex1, 'fontSizeSm12', 'fontWeightMedium')}>From</label>
             </div>
             <div className={clsx(stylesGlobal.flex1, stylesCalender.calenderInput, 'flex', 'justifyContentFS', 'alignItemCenter', 'gap5')}>
                <div className={clsx('inputwraperClanser', stylesGlobal.flex3, 'flex', 'justifyContentCenter', 'alignItemCenter', 'gap5')}>
                    <DatePicker    selected={startDate}
        onChange={(date) => setTempDate(date)}
        onClickOutside={() => setIsOpen(false)}
        onInputClick={() => setIsOpen(true)}
        open={isOpen}
        shouldCloseOnSelect={false} // Prevent auto-close
        calendarClassName="custom-calendar"
        portalId="datepicker-portal" // Move portal to this div
        maxDate={new Date()} // 🔒 disables future dates
        ref={datepickerRefFrom}
        renderCustomHeader={({
          date,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        }) => (
          <div className="custom-header">
            <div className="custom-header-year-date">
            <div className={clsx(stylesCalender.customHeaderYear, stylesGlobal.flex111, 'fontSizeSm', 'fontWeightMedium')}>{date.getFullYear()}</div>
            <div className={clsx(stylesCalender.customHeaderYearDate, stylesGlobal.flex111, 'fontSizeMd', 'fontWeightBold')}>
              {date.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "2-digit" })}
            </div>
            </div>
            <div className="month-controls">
              <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} className={clsx(stylesCalender.customHeaderMonthControlLeft, 'flex', 'justifyContentFS', 'alignItemLeft', stylesGlobal.flex1, 'fontSizeSm12', 'fontWeightBold')}><img src={monthControlLeftIcon} alt="monthControlLeftIcon" width={24} height={24} /></button>
              <span className={clsx(stylesCalender.customHeaderMonthControl, stylesGlobal.flex1, 'fontSizeSm12', 'fontWeightMedium', 'textAlignCenter')}>{date.toLocaleDateString("en-US", { month: "long", year: "numeric" })}</span>
              <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} className={clsx(stylesCalender.customHeaderMonthControlRight, 'flex', 'justifyContentFE', 'alignItemRight', stylesGlobal.flex1, 'fontSizeSm12', 'fontWeightBold')}><img src={monthControlRightIcon} alt="monthControlRightIcon" width={24} height={24} /></button>
            </div>
          </div>
        )}
        calendarContainer={({ children }) => (
          <div className="custom-calendar-container">
            {children}
            <div className="calendar-footer">
              <button className="cancel-btn" onClick={handleCancel}>CANCEL</button>
              <button className="ok-btn" onClick={handleOk}>OK</button>
            </div>
          </div>
        )} dateFormat="dd/MM/yy" className={stylesCalender.calenderInputDatePicker} /></div>
                <div className={clsx(stylesGlobal.flex1)}>
                    <img src={clanderIcon} alt="start from date" width={24} height={24} onClick={focusOnFromDateInput}/>
                </div>
             </div>
        </div>;
  };

export const ToDatePicker = ({datepickerRefTo}: {datepickerRefTo:any}) => {
    const { endDate, setEndDate, startDate, isDateValid, setIsDateValid } = useContext(CalenderContext);
    const [tempEndDate, setTempEndDate] = useState<Date | null>(null);
    const [isOpen, setIsOpen] = useState(false);
   

    const handleCancel = () => {
        setTempEndDate(endDate); // Reset temp date to previously selected date
        setIsOpen(false); // Close the calendar
        setIsDateValid(false);
      };
    
      const handleOk = () => {
           // Set time to 23:59:59
           if (tempEndDate !== null) {
            const adjustedDate = new Date(tempEndDate); // TypeScript-safe now
            adjustedDate.setHours(23, 59, 59, 999);
            setEndDate(adjustedDate); 
          } else {
            setEndDate(null); // Handle case where user clears date
          }
        setIsOpen(false); // Close the calendar
        setIsDateValid(false);
      };

      const focusOnToDateInput = () => { 
        setIsOpen(true);
        setIsDateValid(false);

       // datepickerRefFrom.current?.focus();
      }

      const onTodatechangeValue = (date: Date | null) =>{
        // if(!date || !startDate){ return; }
        // if(startDate.getTime() >= date.getTime()){
        //   return;
        // }
        setTempEndDate(date)
      }


   return <div className={clsx(stylesGlobal.flex1, 'flex', 'justifyContentFS', 'alignItemCenter', 'gap5', stylesCalender.calenderItem,isOpen && stylesCalender.calenderItemOpenTrue, isDateValid && stylesCalender.calenderItemError)} >
             <div className={clsx(stylesGlobal.flex1, stylesCalender.calenderLabel, 'moveupwithouterrorwrapperdiv')}>
               <label className={clsx(stylesGlobal.flex1, 'fontSizeSm12', 'fontWeightMedium')}>To</label>
             </div>
             <div className={clsx(stylesGlobal.flex1, stylesCalender.calenderInput, 'flex', 'justifyContentFS', 'alignItemCenter', 'gap5')}>
                <div className={clsx('inputwraperClanser', stylesGlobal.flex3, 'flex', 'justifyContentCenter', 'alignItemCenter', 'gap5')}><DatePicker  selected={endDate} selectsEnd  onChange={(date) => onTodatechangeValue(date)}
        onClickOutside={() => setIsOpen(false)}
        onInputClick={() => setIsOpen(true)}
        open={isOpen}
        ref={datepickerRefTo}
        shouldCloseOnSelect={false} // Prevent auto-close
        calendarClassName="custom-calendar"
        portalId="datepicker-portal" // Move portal to this div
        maxDate={new Date()} // 🔒 disables future dates
        renderCustomHeader={({
          date,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        }) => (
          <div className="custom-header">
            <div className="custom-header-year-date">
            <div className={clsx(stylesCalender.customHeaderYear, stylesGlobal.flex1, 'fontSizeSm', 'fontWeightMedium')}>{date.getFullYear()}</div>
            <div className={clsx(stylesCalender.customHeaderYearDate, stylesGlobal.flex1, 'fontSizeMd', 'fontWeightBold')}>
              {date.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "2-digit" })}
            </div>
            </div>
            <div className="month-controls">
              <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} className={clsx(stylesCalender.customHeaderMonthControlLeft, 'flex', 'justifyContentFS', 'alignItemLeft', stylesGlobal.flex1, 'fontSizeSm12', 'fontWeightBold')}>{"<"}</button>
              <span className={clsx(stylesCalender.customHeaderMonthControl, stylesGlobal.flex1, 'fontSizeSm12', 'fontWeightMedium', 'textAlignCenter')}>{date.toLocaleDateString("en-US", { month: "long", year: "numeric" })}</span>
              <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} className={clsx(stylesCalender.customHeaderMonthControlRight, 'flex', 'justifyContentFE', 'alignItemRight', stylesGlobal.flex1, 'fontSizeSm12', 'fontWeightBold')}>{">"}</button>
            </div>
          </div>
        )}
        calendarContainer={({ children }) => (
          <div className="custom-calendar-container">
            {children}
            <div className="calendar-footer">
              <button className="cancel-btn" onClick={handleCancel}>CANCEL</button>
              <button className="ok-btn" onClick={handleOk}>OK</button>
            </div>
          </div>
        )} dateFormat="dd/MM/yy" className={stylesCalender.calenderInputDatePicker} /></div>
                <div className={clsx(stylesGlobal.flex1)}>
                    <img src={clanderIcon} alt="closeIcon" width={24} height={24} onClick={focusOnToDateInput}/>
                </div>
             </div>
        </div>;
  };


export const Overlay =  () =>{
    return (
        <div className={stylesCalender.overlay_calender} />
    )
}

export const CalenderContainer = ({closeCalenderHandler, t}: CalenderProps) =>{
    const { startDate, setStartDate, endDate, setEndDate, isDateValid, setIsCalenderOpen } = useContext(CalenderContext);
    const datepickerRef = useRef<HTMLDivElement>(null);
    const datepickerRefFrom = useRef<HTMLDivElement>(null);
    const datepickerRefTo = useRef<HTMLDivElement>(null);
    const { setPayloadDataState, PayloadDataState } = useContext(TransactionHistoryContext);



    const clearDateHandler = () => {
        setStartDate(null);
        setEndDate(null);
        const { dateFilter, ...cleanedState } = PayloadDataState;
        setPayloadDataState({...cleanedState});
    }

    const applyDateHandler = () => {
      setStartDate(startDate);
      setEndDate(endDate);
      setIsCalenderOpen(false);
    }

    return (<><div ref={datepickerRef} id="datepicker-portal" className={clsx('datepickerWrapper', stylesGlobal.container)}></div>
        <div className={clsx(stylesCalender.calenderContainer, stylesGlobal.container)} >
             
            <div className={clsx(stylesCalender.calenderHeader, 'flex', 'justifyContentFS', 'alignItemCenter', 'mb20', 'mt10')}>
                <div className={clsx(stylesCalender.calenderHeaderItem, 'fontSizeSm', 'fontWeightBold', stylesGlobal.flex2 )}>{t('selectDateRange')}</div>
                <div className={clsx(stylesCalender.closeItem, stylesGlobal.flex1, 'textAlignRight')} onClick={closeCalenderHandler}>
                    <img src={closeIcon} alt="closeIcon" width={24} height={24}/>
                </div>
            </div>
            
            <div className={stylesCalender.calenderBody}>
                <div className={stylesCalender.calenderBodyItem}>
                    <div className={clsx(stylesCalender.calenderBodyItemDate, 'flex', 'justifyContentFS', 'alignItemCenter', 'gap5')}>
                        <div className={clsx(stylesCalender.calenderBodyItemDateStart, stylesGlobal.flex1, isDateValid && stylesCalender.calenderBodyItemDateStartError)}>
                            <FromDatePicker datepickerRefFrom={datepickerRefFrom}/>
                        </div>
                    <div className={clsx(stylesCalender.calenderBodyItemDateEnd, stylesGlobal.flex1)}>
                        <ToDatePicker datepickerRefTo={datepickerRefTo} />
                    </div>
                </div>
                {isDateValid && <div className={clsx(stylesCalender.calenderBodyItemDateError, 'flex', 'justifyContentFs', 'alignItemCenter','mt5')}>{t('invalidDateRange')}</div>}
                 <div className={clsx(stylesGlobal.flex1, 'flex', 'justifyContentFS', 'alignItemCenter', 'gap5', 'mt20')}>
                        <button onClick={clearDateHandler} className={clsx(stylesGlobal.flex1, stylesCalender.submitButton, stylesCalender.clanBorder, 'fontSizeSm12', 'fontWeightMedium', 'textAlignCenter')}>Clear</button>
                        <button onClick={applyDateHandler} className={clsx(stylesGlobal.flex1, stylesCalender.submitButton, stylesCalender.enabledcolor, 'fontSizeSm12', 'fontWeightMedium', 'textAlignCenter', ((isDateValid || startDate==null || endDate==null)) && stylesCalender.disabledButton)} disabled={isDateValid || startDate==null || endDate==null}>Apply</button>
                    </div>
            </div>
        </div>
        </div></>
    ) 
} 



const Calender: React.FC<CalenderProps> = ({isOpenCalender, closeCalenderHandler}) => {

    const { t } = useTranslation();

    useEffect(() => {
        if (isOpenCalender) {
          document.body.classList.add('stopscrolling');
        } else {
          document.body.classList.remove('stopscrolling');
        }
      }, [isOpenCalender]);

  return  (
    <>
    {ReactDOM.createPortal(<Overlay />, document.getElementById('modal-root') as HTMLElement)}
    {ReactDOM.createPortal(<CalenderContainer closeCalenderHandler={closeCalenderHandler} t={t} />, document.getElementById('modal-root') as HTMLElement)}
    </>
  )
}

export default Calender;
